import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { AppContext, AppProviderDispatch } from '../shared/app-context';
import useRestService from '../shared/rest-service';

interface SegmentOverviewFilters {
  users: {
    name: string;
    id: string;
  }[];
}

interface AdminSegmentOverviewFilters extends SegmentOverviewFilters {
  clients: {
    name: string;
    id: string;
  }[];
}

const staleTime = 1000 * 60 * 30;

export function useSegmentsFiltersAdmin() {
  const { fetchWrapper } = useRestService();

  return useQuery<AdminSegmentOverviewFilters, Error>(
    ['segments-admin-filters'],
    () => {
      return fetchWrapper(`api/segments/filters`);
    },
    {
      staleTime
    }
  );
}

export function useSegmentsFilters() {
  const { fetchWrapper } = useRestService();
  const appState = React.useContext<AppProviderDispatch>(AppContext);

  return useQuery<SegmentOverviewFilters, Error>(
    ['segments-filters', appState.state.clientId],
    () => {
      return fetchWrapper(`api/${appState.state.clientId}/segments/filters`);
    },
    {
      staleTime
    }
  );
}
